import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { FiSearch } from "react-icons/fi";
import { useRequest } from "../../../hooks/useRequest";
import { useLocation, useNavigate } from "react-router-dom";
import useDebounce from "../../../hooks/useDebounce";

const SearchbarStyle = styled.form`
  height: 39px;
  display: flex;
  position: relative;
  border-radius: 3px;
  overflow: clip;
  flex: 1;
  input {
    height: 39px;
    width: 100%;
    padding-left: 12px;
  }
    .showBorder{
        border: 1px solid #ababab;
        }
  .search__button {
    width: 39px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    position: absolute;
    right: 0;
    .icon {
      display: block;
      color: #fff;
      font-size: 18px;
    }
  }
`;

const SearchbarStyleWrapper = styled.div`
  position: relative;
  z-index: 9;
  flex: 1;
  .search__results {
    max-height: 200px;
    overflow: scroll;
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    width: 100%;
    background-color: #fff;
    border: 0.75px solid #d2d1d1;
    border-radius: 4px;
    z-index: 5;
    .search__item {
      border: 0.75px solid #d2d1d1;
      padding: 12px;
      text-transform: capitalize;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
      cursor: pointer;
      &:hover {
        background: #ffeeee;
      }
    }
  }
`;

const Searchbar = ({showBorder=false}) => {
  const [searchValue, setSearchValue] = useState("");
  const [fetchSearchResult] = useRequest();
  const [searchResults, setSearchResults] = useState([]);
  const { search } = useLocation();
  const navigate = useNavigate();
  const searchRef = useRef(null);
  useDebounce(
    async () => {
      if (!searchValue?.length) return;
      const path = `/product/search?limit=20&page=1&search=${searchValue}`;
      const response = await fetchSearchResult({ path });
      setSearchResults(response?.data?.docs);
    },
    [searchValue],
    500
  );

  // Handle clicks outside the search component
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchResults([]);
      }
    };

    if (searchResults.length > 0) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [searchResults.length]);


  const handleNavigate = e => {
    e.preventDefault();
    e.stopPropagation();
    // navigate(`/search/?name=${searchValue}`)
    // searchParams.append("search", searchValue);
    // const newUrl = `/search/?${searchParams.toString()}`;
    // e.prevent
    navigate(`/search/?search=${searchValue}`);
    setSearchValue('');
    setSearchResults([]);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchValue.trim()) {
      handleNavigate(e);
    }
  }

  return (
    <SearchbarStyleWrapper ref={searchRef}>
      <SearchbarStyle
      onSubmit={handleSubmit}
      >
        <input
          type="search"
          placeholder="Search"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          className={showBorder && 'showBorder'}
        />
        <button onClick={handleNavigate} type="button" className="search__button">
          <FiSearch className="icon" />
        </button>
      </SearchbarStyle>
      {searchValue && searchResults?.length > 0 && (
        <div className="search__results">
          {searchResults?.map((item) => (
            <div
              key={item?._id}
              className="search__item"
              onClick={() => {
                setSearchValue("");
                setSearchResults([]);
                navigate(`/product/${item?.slug}?id=${item?._id}`);
              }}
            >
              {item?.name}
            </div>
          ))}
        </div>
      )}
    </SearchbarStyleWrapper>
  );
};

export default Searchbar;
